import { AuthLayout } from './AuthLayout';

const name = 'AuthLayout';
export { name, AuthLayout };

export type { AuthLayoutProps } from './types';
